var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-desktop is-desktop"},[_c('PricingTableDesktopDetail',{attrs:{"id":'toogle-plan-' + _vm.activePlan,"scrollToPricing":_vm.scrollToPricing,"tooglePlanDropdown":_vm.tooglePlanDropdown,"tableData":_vm.featuresByPlan[_vm.activePlan],"activePlan":_vm.activePlan,"togglePlan":_vm.togglePlan,"permission":_vm.permission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }